export default __webpack_public_path__ + "static/scam-alert-image-5-61c3394227217f936a74a59e2566b58b.webp";